// extracted by mini-css-extract-plugin
module.exports = {"toggle":"HeaderToggle-module--toggle--yiBlw","toggleFixed":"HeaderToggle-module--toggleFixed--1ky64"};